import React, { useState, useEffect, useRef } from 'react';
import { Hidden, IconButton, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import useNeoWrapperDefaultTopBarStyles from './neo-wrapper-default-top-bar.styles';
import { useNeoWrapperDrawerContext } from '../neo-wrapper-drawer/neo-wrapper-drawer.context';
import Invite from '../../invite/invite';

interface NeoWrapperDefaultTopBarProps {
  title: string;
  journeyId?: string;
  isHamburgerIconHidden?: boolean;
}

const NeoWrapperDefaultTopBar: React.FC<NeoWrapperDefaultTopBarProps> = ({ title, journeyId, isHamburgerIconHidden }) => {
  const classes = useNeoWrapperDefaultTopBarStyles();
  const { toggleDrawer } = useNeoWrapperDrawerContext();
  const [showTooltip, setShowTooltip] = useState(false);
  

  useEffect(() => {
    if (!journeyId) return;
     const dismissed = localStorage.getItem('inviteTooltipDismissed');

    if (!dismissed) {
      const timer = setTimeout(() => {
        setShowTooltip(true);
      }, 800); 

       return () => clearTimeout(timer);
    }
  }, [journeyId]);

  const handleDismiss = () => {
    setShowTooltip(false);
    localStorage.setItem('inviteTooltipDismissed', 'true');
  };

  // Note: I overroad the MUI Hidden component's prop list with a type assertion. This could potential cause problems
  // and needs a better long-term solution.
  return (
    <>
      {isHamburgerIconHidden ? ''
        : (
          <Hidden 
            mdUp
            {...{children: 
              <>
                <IconButton
                  className={`hamburgerIcon ${classes.hamburgerIcon}`}
                  onClick={toggleDrawer}
                  edge="start"
                >
                  <MenuIcon />
                </IconButton>
              </>
            } as any}
            />
        )}
      <div className={classes.titleContainer}>
        <Typography className={`containerTitle ${classes.title}`} variant="h2" noWrap>
          {title}
        </Typography>
        {journeyId && (
          <div className={classes.inviteWrapper}>
            <Invite showButton={true} journeyId={journeyId} />

            {showTooltip && (
              <div className={classes.inviteTooltip}>
                <div className={classes.inviteTooltipArrow} />
                
                <Typography className={classes.tooltipText}>
                  Invite a team member to help fill out your application.
                </Typography>
                
                <Typography
                  className={classes.gotIt}
                  onClick={handleDismiss}
                >
                  Got It
                </Typography>
              </div>
            )}
          </div>
        )}
     </div>
   </>
  );
};

export default NeoWrapperDefaultTopBar;